import { useUser } from 'contexts/UserContext'
import { menuItems } from 'data/menuItems'
import PropTypes from 'prop-types'
import { useLocation } from 'wouter'
import MenuItems from './MenuItems'

export default function Menu({ isSidebarOpen }) {
  const { user } = useUser()
  const [location] = useLocation()

  return (
    menuItems &&
    menuItems
      .filter((item) => {
        if (!item.requiredRoles) return true
        return item.requiredRoles.includes(Number(user?.role_id))
      })
      .map((item) => (
      <MenuItems
        key={item?.slug || item?.title}   // IMPORTANTE: no uses index
        item={item}
        user={user}
        location={location}
        isSidebarOpen={isSidebarOpen}
      />
    ))
  )
}

Menu.propTypes = {
  isSidebarOpen: PropTypes.bool
}
